import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule, MatDialog } from '@angular/material/dialog';
import { Prospeccion } from '../../models/prospeccion';
import { GestionclientesService } from '../../gestionclientes.service';
import { SeguimientoProspeccion } from '../../models/seguimientoProspeccion';
import { AuthService } from 'src/app/security/auth.service';
import { Cliente } from 'src/app/shared/model/ajustesUsuario/cliente.model';
import { ProyectosService } from 'src/app/proyectos/proyectos.service';
import swal from 'sweetalert2';

import { NgIf, NgFor, DatePipe, CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatRadioModule } from '@angular/material/radio';

@Component({
  selector: 'app-modal-seguimiento',
  standalone: true,
  templateUrl: './modal-seguimiento.component.html',
  styleUrls: ['./modal-seguimiento.component.css'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgIf,
    NgFor,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatRadioModule,
    MatDialogModule
  ],
})
export class ModalSeguimientoComponent implements OnInit {
  datosform: FormGroup;
  datosformProspecto: FormGroup;
  registroSeguimiento: boolean = false;
  datosformRegisroSeguimiento: FormGroup;
  objetoSeguimiento: SeguimientoProspeccion;
  objetoProspecto: Prospeccion;
  isValid = false;
  minDate: Date;
  esConsulta: boolean;
  seguimiento: SeguimientoProspeccion;
  agregarProspecto: boolean = false;
  clientes: Cliente[] = [];
  titulo: string;
  seguimientos: Array<SeguimientoProspeccion>;
  seguimientosLista: SeguimientoProspeccion[] = [];
  mostrarRecientes = false;
  finalizado: boolean = false;
  fecha: string;
  usuarioProspecto: number;
  usuarioSeguimiento: number;


  constructor(
    public dialogRef: MatDialogRef<ModalSeguimientoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formbuilder: FormBuilder,
    private dialog: MatDialog,
    private serviceCliente: GestionclientesService,
    private authS: AuthService,
    private proyectosService: ProyectosService
  ) { }

  ngOnInit() {
    this.llenarDatos();
    
    this.datosformRegisroSeguimiento = this.formbuilder.group({
      fecha: [''],
      actividad: ['', Validators.required],
      compromiso: ['' , Validators.required],
      fechaSigSeguimiento: ['', Validators.required],
      responsable: [''],
      nota: [''],
      observaciones: [''],
      estatus: ['']
    });
    this.datosformRegisroSeguimiento.get('observaciones').disable();
    this.datosformProspecto = this.formbuilder.group({
      cliente: ['', Validators.required],
      descripcion: ['', Validators.required]
    });

    if (this.data.item !== null && this.data.item !== undefined) {
      this.esConsulta = true;
      if(this.usuarioSeguimiento != null && this.usuarioSeguimiento != undefined){
        this.objetoSeguimiento.id_usuario = this.usuarioSeguimiento;
      }
      this.objetoSeguimiento = this.data.item as SeguimientoProspeccion;
      this.objetoSeguimiento.id_prospeccion = this.data.item.id;
      this.titulo = "Consulta prospecto";
      this.consultaSeguimiento(this.objetoSeguimiento.id_prospeccion);
      this.objetoSeguimiento.estatus = null;
      
    }
    else {
      this.objetoSeguimiento = new SeguimientoProspeccion();
      this.esConsulta = false;
      this.agregarProspecto = true;
      this.consultaClientes();
      this.titulo = "Agrega prospecto";
    }
  
  }

  onRadioCompromisoChange() {
    if (this.objetoSeguimiento.estatus===1) {
        this.datosformRegisroSeguimiento.get('observaciones').enable();
    }else{
        this.datosformRegisroSeguimiento.get('observaciones').disable();
    }
}

  registroSeguimientoBtn(): void {
    this.registroSeguimiento = true;
    this.esConsulta = false;
  }

  cancelarRegistroSeguimieto(): void {
    this.datosformRegisroSeguimiento.reset();
    this.registroSeguimiento = false;
    this.datosformRegisroSeguimiento.get('observaciones').disable();
    this.finalizado = true;
  }



  save(): void {
    this.objetoSeguimiento.id_usuario = this.usuarioSeguimiento;
    this.serviceCliente.guardarSeguimiento(this.objetoSeguimiento).subscribe(
      (respuesta: any) => {
        if (respuesta) {
          this.registroSeguimiento = false;
          this.datosformRegisroSeguimiento.reset();
          swal.fire({
            text: 'Seguimiento registrado exitosamente',
            buttonsStyling: false,
            customClass: {
              confirmButton: 'btn btn-success',
              cancelButton: 'btn btn-danger',
            },
            icon: 'success',
          }).then((result) => {
            this.dialogRef.close();
          });
        } else {
          console.error('La respuesta del servicio de seguimiento no es válida :c', respuesta);
        }
      },
      (error) => {
        console.error('Error al guardar el seguimiento :c', error);
      }
    );
  }


  onNoClick(): void {
    this.dialogRef.close();
  }

  llenarDatos() {
    this.authS.getSesion().subscribe(res => {
      if(res != null && res != undefined){
        this.usuarioProspecto = res.usuario.id;
        this.usuarioSeguimiento = res.usuario.id;
      }
    });

  }

  consultaClientes(): void {
    this.proyectosService
      .obtenerProspecto(new Cliente())
      .subscribe(response => {
        const clientes = Array.isArray(response) ? response : [];

        setTimeout(() => {
          this.clientes = clientes;
        });
      });
  }


  guardaProspecto(): void {
    if (this.datosformProspecto.valid) {
      const formData = this.datosformProspecto.value;

      if(this.data.prospectos != null && this.data.prospectos != undefined){
            const clienteExistente = this.data.prospectos.find(cliente => cliente.cliente === formData.cliente);
                  if (clienteExistente) {
                    swal.fire({
                      text: `El prospecto ${clienteExistente.razonsocial} ya está registrado.`,
                      buttonsStyling: false,
                      customClass: {
                        confirmButton: 'btn btn-danger',
                      },
                      icon: 'warning',
                    });
                    return; 
                  }
      }
     
      if(this.usuarioProspecto != null && this.usuarioProspecto != undefined){
        formData.usuario_resgistro = this.usuarioProspecto;
      }
      this.serviceCliente.guardarProspecto(formData).subscribe(
        (respuesta) => {
          swal.fire({
            text: 'Prospecto registrado exitosamente',
            buttonsStyling: false,
            customClass: {
              confirmButton: 'btn btn-success',
              cancelButton: 'btn btn-danger',
            },
            icon: 'success',
          }).then((result) => {
            this.dialogRef.close();
          });
        }
      );
    } else {
      console.error('Formulario no válido. Por favor, complete los campos requeridos correctamente.');
    }
  }

  consultaSeguimiento(idProspecto: number) {
    this.serviceCliente.consultaSeguimiento(idProspecto).subscribe(res => {
        this.seguimientosLista = res.list;
    });
  }

  getseguimientosAMostrar(): SeguimientoProspeccion[] {
    if (this.mostrarRecientes) {
      // Igual que reduce sin valor inicial: arranca con el primero y lo compara contra los demás.
      const [primero, ...resto] = this.seguimientosLista;
      const recursoMasReciente = resto.reduce((prev, current) => (new Date(prev.fecha) > new Date(current.fecha)) ? prev : current, primero);
      return [recursoMasReciente];
    } else {
      return this.seguimientosLista;
    }
  }

  toggleMostrarRecientes() {
    this.mostrarRecientes = !this.mostrarRecientes;
  }


  editarSeguimiento(seguimiento: number) {
    this.esConsulta = true;
    this.consultaSeguimiento(this.objetoSeguimiento.id_prospeccion);
    this.objetoSeguimiento.id_seguimiento = seguimiento;
    this.cargarDatosSeguimientoEnFormulario(seguimiento);
    
  }

  cargarDatosSeguimientoEnFormulario(idSeguimiento: number) {
    const seguimientoSeleccionado = this.seguimientosLista.find(seguimiento => seguimiento.id_seguimiento === idSeguimiento);
    if (seguimientoSeleccionado) {
      this.objetoSeguimiento = seguimientoSeleccionado;
      if (this.objetoSeguimiento.estatus===1) {
        this.datosformRegisroSeguimiento.get('observaciones').enable();
    }else{
        this.datosformRegisroSeguimiento.get('observaciones').disable();
    }
      this.registroSeguimiento = true;
    } else {
      this.datosformRegisroSeguimiento.reset();
    }
  }

  test(fecha: string) {
    var fechaActual = new Date();

    var desplazamientoHorarioEnMinutos = fechaActual.getTimezoneOffset();

    var signo = desplazamientoHorarioEnMinutos > 0 ? '-' : '+';
    var horas = Math.floor(Math.abs(desplazamientoHorarioEnMinutos) / 60);
    var minutos = Math.abs(desplazamientoHorarioEnMinutos) % 60;

    var desplazamientoHorarioFormatoISO = signo + (horas < 10 ? '0' : '') + horas + ':' + (minutos < 10 ? '0' : '') + minutos;

    let result = fecha + 'T00:00:00' + desplazamientoHorarioFormatoISO;
    // let resultEnd = this.data.fechaFin + 'T00:00:00' + desplazamientoHorarioFormatoISO;

    this.fecha = fecha;

    this.fecha = new Date(result).toISOString();
}



}
